export const homeTranslations = {
  'en-GB': {
    home: {
      meta: {
        title: 'Colozoo – Creating happiness!',
        description: 'Creative art supplies designed by artists for artists and families. Discover our paints, markers, and art materials. Explore Colozoo on Amazon.',
      },
      title: 'Colozoo: Creating Happiness',
      howWeStarted: {
        title: 'How we got our start?',
        content: 'A young couple of art and design students in Germany found themselves faced with uninspired art materials that just didn’t spark their creativity. They wanted more – something playful, vibrant, and lively. That’s how the idea for Colozoo was born - a colorful world where creativity is set free!',
      },
      whatMakesOurProductsUnique: {
        title: 'What makes our products unique?',
        content: 'Every Colozoo product is imagined and designed by artists and designers who know exactly what creative minds crave. Every little detail that only an artist can notice has been carefully considered. We add a touch of creativity to our products so that they not only meet your needs, but inspire you to let your imagination run wild and enjoy every moment of the journey!',
      },
      ourStores: 'Our Amazon Stores',
      visitOurStore: 'Visit our Amazon Store',
      contactUs: 'Contact Us',
      storeLink: 'https://www.amazon.co.uk/stores/Colozoo/page/D00BCC46-3519-4856-B012-FD748CFEE7D6',
      footer_1: 'Colozoo.de',
      footer_2: 'Legal Notice',
      footer_3: 'Privacy Policy',
      siteFooter: {
        site: 'Colozoo.de',
        legal: 'Legal notice',
        privacy: 'Privacy policy',
        help: 'Help & contact',
      },
      cookieConsent: {
        text: 'This website uses cookies and analytics to enhance the user experience. By continuing, you accept our ',
        policy: 'Privacy Policy',
        accept: 'Accept',
      },
    },
  },
  'en-US': {
    home: {
      meta: {
        title: 'Colozoo – Creating happiness!',
        description: 'Creative art supplies designed by artists for artists and families. Discover our paints, markers, and art materials. Shop on Amazon.',
      },
      title: 'Colozoo: Creating Happiness',
      howWeStarted: {
        title: 'How we got our start?',
        content: 'Colozoo started when a young couple of art and design students in Germany got frustrated with dull, uninspiring art supplies. They wanted more – something fun, bold, and full of energy. Later, as parents, they realized how creative tools could inspire children and bring families together through art. That’s how Colozoo was born – a colorful world where creativity runs wild for artists of all ages.',
      },
      whatMakesOurProductsUnique: {
        title: 'What makes our products unique?',
        content: 'Every Colozoo product is dreamed up and designed by artists and designers who know exactly what creative minds need – because they’re artists too. And as parents, they understand what families care about. That’s why Colozoo products are not only thoughtfully made, but also fun, safe, and perfect for kids. We don’t just make art supplies – we create tools for imagination, play, and joyful exploration.',
      },
      ourStores: 'Our Amazon Stores',
      visitOurStore: 'Visit our Amazon Store',
      contactUs: 'Contact Us',
      storeLink: 'https://www.amazon.com/stores/Colozoo/page/C207523A-55EB-4191-B263-65E44BA822FD',
      footer_1: 'Colozoo.com',
      footer_2: 'Legal Notice',
      footer_3: 'Privacy Policy',
      siteFooter: {
        site: 'Colozoo.de',
        legal: 'Legal notice',
        privacy: 'Privacy policy',
        help: 'Help & contact',
      },
      cookieConsent: {
        text: 'This website uses cookies and analytics to enhance the user experience. By continuing, you accept our ',
        policy: 'Privacy Policy',
        accept: 'Accept',
      },
    },
  },
  de: {
    home: {
      meta: {
        title: 'Colozoo – Schaffe Glück!',
        description: 'Kreative Bastelmaterialien, von Künstlern für Künstler und Familien entworfen. Entdecken Sie Farben, Marker und Kunstmaterialien. Jetzt auf Amazon shoppen!',
      },
      title: 'Colozoo: Creating Happiness',
      howWeStarted: {
        title: 'Wie ist Colozoo entstanden?',
        content: 'Colozoo entstand, als ein junges Paar von Kunst- und Designstudierenden in Deutschland genug von langweiligen, uninspirierenden Bastelmaterialien hatte. Sie wollten mehr – etwas Verspieltes, Lebendiges, Farbenfrohes. Später, als sie Eltern wurden, merkten sie, wie wichtig kreative Materialien auch für Kinder sind und wie sie Familien zusammenbringen können. So wurde Colozoo geboren – eine bunte Welt, in der Kreativität keine Grenzen kennt, für Jung und Alt.',
      },
      whatMakesOurProductsUnique: {
        title: 'Was macht unsere Produkte besonders?',
        content: 'Jedes Colozoo-Produkt wird von Künstlerinnen, Künstlern und Designerinnen entworfen, die genau wissen, was kreative Köpfe brauchen – weil sie selbst kreativ sind. Als Eltern wissen sie auch, worauf Familien Wert legen. Deshalb sind unsere Produkte nicht nur durchdacht und hochwertig, sondern auch sicher, unterhaltsam und kindgerecht. Wir machen nicht nur Bastelmaterialien – wir schaffen Werkzeuge für Fantasie, Spiel und kreative Entfaltung.',
      },
      ourStores: 'Unsere Amazon Shops',
      visitOurStore: 'Besuchen Sie unseren Amazon Store',
      contactUs: 'Kontaktiere uns',
      storeLink: 'https://www.amazon.de/stores/Colozoo/page/088F6D23-55D5-4281-ACB4-0E0BFBDD99A3',
      footer_1: 'Colozoo.de',
      footer_2: 'Impressum',
      footer_3: 'Datenschutz',
      siteFooter: {
        site: 'Colozoo.de',
        legal: 'Impressum',
        privacy: 'Datenschutz',
        help: 'Hilfe & Kontakt',
      },
      cookieConsent: {
        text: 'Diese Website verwendet Cookies und Analysedienste, um die Benutzererfahrung zu verbessern. Durch die weitere Nutzung akzeptieren Sie unsere ',
        policy: 'Datenschutzerklärung',
        accept: 'Akzeptieren',
      },
    },
  },
  fr: {
    home: {
      meta: {
        title: 'Colozoo – Créer du bonheur!',
        description: 'Fournitures d\'art créatif conçues par des artistes pour les artistes et les familles. Découvrez nos peintures, marqueurs et matériels artistiques. Sur Amazon!',
      },
      howWeStarted: {
        title: 'Comment avons-nous commencé?',
        content: 'Un jeune couple d\'étudiants en art et en design en Allemagne s\'est retrouvé face à du matériel artistique sans inspiration qui ne stimulait tout simplement pas leur créativité. Ils voulaient plus - quelque chose de ludique, de vibrant et de vivant. C\'est ainsi qu\'est née l\'idée de Colozoo - un monde coloré où la créativité est libérée!',
      },
      whatMakesOurProductsUnique: {
        title: 'Qu\'est-ce qui rend nos produits uniques?',
        content: 'Chaque produit Colozoo est imaginé et conçu par des artistes et des designers qui savent exactement ce que les esprits créatifs recherchent. Chaque petit détail que seul un artiste peut remarquer a été soigneusement étudié. Nous ajoutons une touche de créativité à nos produits pour qu\'ils répondent non seulement à vos besoins, mais vous inspirent également à laisser libre cours à votre imagination et à profiter de chaque instant du voyage!',
      },
      ourStores: 'Nos magasins',
      visitOurStore: 'Visitez notre boutique Amazon',
      contactUs: 'Contactez-nous',
      storeLink: 'https://www.amazon.fr/stores/Colozoo/page/315C207E-1141-4BBF-83D1-F857DA73F838',
      footer_1: 'Colozoo.fr',
      footer_2: 'Mentions légales',
      footer_3: 'Politique de confidentialité',
      siteFooter: {
        site: 'Colozoo.de',
        legal: 'Mentions légales',
        privacy: 'Confidentialité',
        help: 'Aide & contact',
      },
    },
  },
  it: {
    home: {
      meta: {
        title: 'Colozoo – Creare felicità!',
        description: 'Forniture artistiche creative progettate da artisti per artisti e famiglie. Scopri i nostri colori, pennarelli e materiali artistici. Su Amazon!',
      },
      howWeStarted: {
        title: 'Come abbiamo iniziato?',
        content: 'Una giovane coppia di studenti di arte e design in Germania si è trovata di fronte a materiali artistici poco stimolanti che non stimolavano la loro creatività. Volevano di più - qualcosa di giocoso, vibrante e vivace. È così che è nata l\'idea di Colozoo - un mondo colorato in cui la creatività è libera!',
      },
      whatMakesOurProductsUnique: {
        title: 'Cosa rende unici i nostri prodotti?',
        content: 'Ogni prodotto Colozoo è immaginato e progettato da artisti e designer che sanno esattamente cosa desiderano le menti creative. Ogni piccolo dettaglio che solo un artista può notare è stato attentamente considerato. Aggiungiamo un tocco di creatività ai nostri prodotti in modo che non solo soddisfino le tue esigenze, ma ti ispirino anche a dare sfogo alla tua immaginazione e a goderti ogni momento del viaggio!',
      },
      ourStores: 'I nostri negozi',
      visitOurStore: 'Visita il nostro negozio Amazon',
      contactUs: 'Contattaci',
      storeLink: 'https://www.amazon.it/stores/Colozoo/page/6FBDACCD-D6A8-4017-971A-15D2488DE0D2',
      footer_1: 'Colozoo.it',
      footer_2: 'Note legali',
      footer_3: 'Informativa sulla privacy',
      siteFooter: {
        site: 'Colozoo.de',
        legal: 'Note legali',
        privacy: 'Privacy',
        help: 'Aiuto & contatti',
      },
    },
  },
  es: {
    home: {
      meta: {
        title: 'Colozoo – ¡Crear felicidad!',
        description: 'Suministros de arte creativo diseñados por artistas para artistas y familias. Descubre nuestras pinturas, marcadores y materiales artísticos. ¡En Amazon!',
      },
      howWeStarted: {
        title: '¿Cómo empezamos?',
        content: 'Una joven pareja de estudiantes de arte y diseño en Alemania se encontró con materiales de arte poco inspiradores que simplemente no despertaban su creatividad. Querían más, algo lúdico, vibrante y vivo. Así nació la idea de Colozoo, ¡un mundo colorido donde la creatividad se libera!',
      },
      whatMakesOurProductsUnique: {
        title: '¿Qué hace que nuestros productos sean únicos?',
        content: 'Cada producto de Colozoo es imaginado y diseñado por artistas y diseñadores que saben exactamente lo que anhelan las mentes creativas. Cada pequeño detalle que solo un artista puede notar ha sido cuidadosamente considerado. ¡Agregamos un toque de creatividad a nuestros productos para que no solo satisfagan sus necesidades, sino que también lo inspiren a dejar volar su imaginación y a disfrutar cada momento del viaje!',
      },
      ourStores: 'Nuestras tiendas',
      visitOurStore: 'Visita nuestra tienda de Amazon',
      contactUs: 'Contáctenos',
      storeLink: 'https://www.amazon.es/stores/Colozoo/page/938FD6BE-3585-4F1E-A08F-47E8AAEC8615',
      footer_1: 'Colozoo.es',
      footer_2: 'Aviso legal',
      footer_3: 'Política de privacidad',
      siteFooter: {
        site: 'Colozoo.de',
        legal: 'Aviso legal',
        privacy: 'Privacidad',
        help: 'Ayuda y contacto',
      },
    },
  },
}
